import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AlertsContext from "common/providers/alerts";
import ObservationGridForm from "./ObservationGridForm";
import restoreItem from "./utils/restoreItem";

function ObservationGrid() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "observation-grids",
    id
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/observation-grids");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataObservationGrid: any) => {
      const observationGrid = { ...dataObservationGrid };

      try {
        if (observationGrid.id) {
          await updateItem(observationGrid.id, observationGrid);
        } else {
          await saveItem(observationGrid);
        }
      } catch (e: any) {
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  const handleRestoreItem = useCallback(
    async (values: any) => {
      await restoreItem(updateItem, values);
    },
    [updateItem]
  );

  return isFetching || (id && !item) ? null : (
    <ObservationGridForm
      onSubmit={onSubmit}
      restoreItem={handleRestoreItem}
      observationGrid={item}
    />
  );
}

export default ObservationGrid;
